module.exports = __webpack_public_path__ + "static/employeeManagement-57c9da1798178d024f3cdacc4d7d3f9a.png";